import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Pharmaceutical = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="banner1">
        <div className="banner-overlay1"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">Solutions / Pharmaceutical</h6>
          <hr />
          <h1 className="banner-title">
            Optimize Healthcare with <br /> Advanced Pharmaceutical Software
          </h1>

          <p>
            Streamline operations, ensure compliance, and enhance
            decision-making across the pharmaceutical lifecycle.
          </p>

          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>

        {/* Add the image element */}
        <img
          className="banner-image"
          src="https://img.freepik.com/free-photo/female-pharmacist-with-table-checking-stock-pharmacy_23-2150359100.jpg"
          alt="Pharmaceutical Solutions"
        />
      </section>

      <section id="about" className="about py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h6 className="col_yell text-center">Pharmaceutical</h6>
              <h2 className="text-center">
                Optimizing Healthcare with Advanced Pharmaceutical Software
                Solutions
              </h2>
              <p className="text-center">
                In the fast-paced pharmaceutical industry, our solutions are
                designed to streamline operations, ensure compliance, and
                enhance decision-making. From drug development to distribution,
                we support every stage of the pharmaceutical lifecycle.
              </p>
            </div>
          </div>
        </div>
      </section>
      <hr />

      <div className="container-fluid" style={{ padding: 40 }}>
        <div className="row serv_h1 mb-4">
          <div className="col-md-12">
            <div className="serv_h1l mb-4">
              <h2 className="text-center">Pharmaceutical Solutions</h2>
              <p className="text-center mb-0">
                Revolutionize your pharmaceutical operations with software
                solutions for better outcomes and efficiency.
              </p>
            </div>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Sales & Marketing Analytics</a>
              </h3>
              <p className="mb-4">
                Leverage data for targeted marketing and sales strategies to
                drive growth.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Supply Chain Management</a>
              </h3>
              <p className="mb-4">
                Enhance inventory control and ensure timely pharmaceutical
                distribution.
              </p>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div className="row serv_h3 mt-4 pt-5 pb-5 mx-0 px-4 bg-black text-white">
            <div className="col-md-8">
              <div className="serv_h3l">
                <h2>Ready to Optimize Your Pharmaceutical Operations?</h2>
                <p className="mt-3">
                  Explore how our pharmaceutical software solutions can enhance
                  decision-making, streamline operations, and ensure compliance.
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/colleagues-working-together-office_23-2148738266.jpg"
                        className="w-100"
                        alt="Consultation"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Pharmaceutical;
